// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { CommunicationsRoutingModule } from './communications-routing.module';

// Custom packages - Components
import { CommunicationsListComponent } from 'src/app/modules/communications/pages/communications-list/communications-list.page';
import { AddCommunicationDialogComponent } from 'src/app/shared/components/dialogs/add-communication-dialog/add-communication-dialog.component';
import { ViewCommunicationDetailDialogComponent } from 'src/app/shared/components/dialogs/view-communication-detail-dialog/view-communication-detail-dialog.component';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    CommunicationsRoutingModule,
    PublicModule,
  ],
  declarations: [
    CommunicationsListComponent,
    AddCommunicationDialogComponent,
    ViewCommunicationDetailDialogComponent,
  ],
  entryComponents: [
    AddCommunicationDialogComponent,
    ViewCommunicationDetailDialogComponent,
  ],
  exports: [
  ]
})
export class CommunicationsModule { }
